import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RegisterUserComponent } from '../../components/register-user/register-user.component';
import { CreateUserRequest } from '../../user.model';
import { UserStore } from '../../user.store';
import { ClientStore } from '@features/client/client.store';
import { AffiliateStore } from '@features/affiliate/affiliate.store';
import { LookupStore } from '@core/lookup/lookup.store';
import { SearchableLookupOption } from '@shared/components/searchable-lookup-select/searchable-lookup-select.component';
import {SHARED_IMPORTS} from "../../../../shared/modules/shared-imports.module";

@Component({
  selector: 'app-user-management-create-page',
  imports: [RegisterUserComponent, ...SHARED_IMPORTS],
  templateUrl: './user-management-create.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UserManagementCreatePage {
  private readonly router = inject(Router);
  protected readonly userStore = inject(UserStore);
  protected readonly clientStore = inject(ClientStore);
  protected readonly affiliateStore = inject(AffiliateStore);
  protected readonly lookupStore = inject(LookupStore);

  protected readonly affiliateOptions = computed<SearchableLookupOption[]>(() =>
    this.affiliateStore.affiliateLookupResponses().map((item) => ({
      id: item.id,
      name: `${item.name} ${item.surname}`.trim(),
      code: null,
    })),
  );

  constructor() {
    this.clientStore.loadClients({ includeInactive: false });
    this.affiliateStore.loadAffiliateLookupResponses();
    this.lookupStore.loadUserManagementLookups();
  }

  protected affiliateSearchChanged(search: string): void {
    this.affiliateStore.loadAffiliateLookupResponses(search);
  }

  protected createUser(request: CreateUserRequest): void {
    this.userStore.createUser(
      request,
      (user) => {
        void this.router.navigate(['/user-management/users', user.id]);
      },
      () => this.confirmLinkAndRetry(request),
    );
  }

  // The identity provider already has a login for this email that Partner Hub has no user for. Linking changes
  // that login's portal, client and role and keeps its existing password, so it only happens on confirmation.
  private confirmLinkAndRetry(request: CreateUserRequest): void {
    const confirmed = window.confirm(
      `A login for ${request.email} already exists in the identity provider but is not linked to a Partner Hub user.

` +
        'Link it to this new user? Its existing password is kept and the password you entered is ignored.',
    );

    if (confirmed) {
      this.createUser({ ...request, linkExistingIdentity: true });
    }
  }
}
